import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/db/client";

/**
 * Global hook that syncs mentions in real-time across the entire app.
 * This runs in the background even when not on the Catch Up page,
 * ensuring the cache is always fresh when the user opens it.
 *
 * Events carry only {table, op, id}, so this invalidates rather than
 * patching the cache: the refetch in useMentions is already scoped to the
 * signed-in user (both by its query filter and by RLS), which also replaces
 * the old payload-filter — events for other users refetch a list that
 * simply doesn't include them.
 */
export const useGlobalMentionsSync = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const channel = supabase
      .channel("global-mentions-sync")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "comment_mentions",
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ["mentions"] });
          queryClient.invalidateQueries({ queryKey: ["unread-mentions-count"] });
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
};
